<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-button
              size="sm"
              variant="outline-success"
              @click="openEditPage"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  isVisibleList: ['Y', 'N'],
}

import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  data() {
    return {
      form: { ...initForm },
    }
  },

  mounted() {
    this.getData()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    getData() {
      this.$emit('getData')
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form.keyword)
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    openEditPage() {
     this.$emit('openAddDrawer')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
